import { useFormContext } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { t } from "@/i18n-js/instance";
import type { ListItem as ListItemProp } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/UlListBlock/UlBlock";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-shared/uikit/Button";
import { ListFieldItem } from "./ListFieldItem";

export interface ListFieldProps {
  name: string;
}

export interface ListItemFormFields {
  [key: string]: ListItemProp[];
}

export const ListField = ({ name }: ListFieldProps) => {
  const { watch, setValue } = useFormContext<ListItemFormFields>();
  const items: ListItemProp[] = watch(name, []);

  const onClickAddItemHandler = () => {
    setValue(name, [
      ...items,
      {
        id: uuidv4(),
        value: `${t("builder_ui.prop_type.list.item")} ${items.length + 1}`,
      },
    ]);
  };

  const onClickDeleteItemHandler = (item: ListItemProp) => {
    // TODO: Add confirmation modal
    const isConfirmed = confirm(
      t("builder_ui.prop_type.list.delete_item_confirmation"),
    );
    if (!isConfirmed) return;

    setValue(
      name,
      items.filter(({ id }) => id !== item.id),
    );
  };

  const onClickDuplicateItemHandler = (item: ListItemProp) => {
    setValue(name, [
      ...items,
      { ...item, id: uuidv4(), value: `${item.value} (copy)` },
    ]);
  };

  return (
    <>
      {items.map((item, index) => (
        <ListFieldItem
          key={item.id}
          item={item}
          name={name}
          index={index}
          onClickDeleteItemHandler={() => onClickDeleteItemHandler(item)}
          onClickDuplicateItemHandler={() => onClickDuplicateItemHandler(item)}
          isDeleteDisabled={items.length < 2}
        />
      ))}
      <div>
        <Button
          variant="circle"
          onClick={onClickAddItemHandler}
          small
          className="flex items-center"
        >
          <Icon type="20-plus-v3" size={20} className="text-white" />
          <span className="pr-2">
            {t("builder_ui.prop_type.list.add_item")}
          </span>
        </Button>
      </div>
    </>
  );
};
